// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:43:42

export default {
  "id": "candy-battle-sweet-survivors",
  "slug": "candy-battle-sweet-survivors",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c353ec8225ce46c0aeb23953e14cd5fc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c353ec8225ce46c0aeb23953e14cd5fc/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Candy Battle: Sweet Survivors",
      "description": "The city is under attack by dangerous zombies, and you must become a hero to save it! Awakened by a dream, you take on the mantle of a human warrior with unlimited potential, joining other survivors to fight against the evil horde. But with the zombies greatly outnumbering you, any mistake could lead to dire consequences. You must find a way to survive this crisis.",
      "instructions": "Just run and gun!",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "arena",
        "guns",
        "upgrade",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "糖果战斗：甜蜜幸存者",
      "description": "城市正遭受危险僵尸的攻击，你必须成为英雄来拯救它！在梦中被唤醒，你承担起一位拥有无限潜力的人类战士的责任，与其他幸存者一起对抗邪恶的僵尸大军。但僵尸的数量远远超过你们，任何错误都可能导致严重的后果。你必须找到一种方法来度过这场危机。",
      "instructions": "快跑快射！",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "竞技场",
        "枪械",
        "升级",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "糖果戰爭：甜蜜倖存者",
      "description": "城市受到危險僵屍的攻擊，你必须成為英雄來拯救它！在夢境中被唤醒，你承擔起一個擁有無限潛力的正常人戰士的角色，加入其他倖存者共同對抗邪惡的烏合之眾。但由於僵屍人數遠遠超過你，任何錯誤都可能導致嚴重後果。你必須找到生存這場危機的方法。",
      "instructions": "只是奔跑和射擊！",
      "genres": [
        "隨意型",
        "射擊類"
      ],
      "tags": [
        "競技場",
        "槍械",
        "升級",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "糖果戰爭：甜蜜生還者",
      "description": "城市受到危險僵屍的攻擊，你必須成為英雄來拯救它！在夢境中被驚醒，你擔任一名擁有無限潛力的正常人武士，與其他倖存者一起對抗邪惡的隊伍。但由於僵屍人數遠遠超過你，任何錯誤都可能導致嚴重後果。你必須找到一條生存之道來應對這次危機。",
      "instructions": "只需逃跑和射擊！",
      "genres": [
        "隨意",
        "射擊"
      ],
      "tags": [
        "擂台",
        "槍械",
        "升級",
        "武器"
      ]
    },
    "ja": {
      "title": "キャンディバトル：スイートサバイバーザーズ",
      "description": "都市は危険なゾンビの攻撃にさらされており、あなたは英雄としてその救出に立ち上がらねばなりません！夢に目覚めたあなたは無限の可能性を持つ人間の戦士の姿を取り、他の生き延びる者たちと共に邪悪な群れと戦います。しかしゾンビが圧倒的に多数派であるため、どんな小さなミスも重大な結果を招くかもしれません。この危機を生き延びる方法を見つける必要があります。",
      "instructions": "ただ走って撃て！",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "アリーナ",
        "銃",
        "アップグレード",
        "武器"
      ]
    },
    "ko": {
      "title": "캔디 전쟁: 맛있는 생존자",
      "description": "도시는 위험한 좀비들의 공격을 받고 있으며, 그를 구하기 위해 영웅이 되어야 합니다! 꿈에 깨어나서, 무한한 잠재력을 가진 인간 전사의 옷을 입고, 다른 생존자들과 함께 악한 병대와 싸우게 됩니다. 하지만 좀비들이 크게 우세하여, 어떤 실수도 끔찍한 결과를 초래할 수 있습니다. 이 위기에서 생존하는 방법을 찾아야 합니다.",
      "instructions": "저지만 달리거나 쏘세요!",
      "genres": [
        "캐주얼",
        "셔터"
      ],
      "tags": [
        "아레나",
        "총",
        "업그레이드",
        "무기"
      ]
    },
    "fr": {
      "title": "Bataille des Bonbons : Survivants Doux",
      "description": "La ville est attaquée par des zombies dangereux, et vous devez devenir un héros pour la sauver ! Réveillé par un rêve, vous prenez le rôle d'un guerrier humain aux potentiel illimité, vous joignant d'autres survivants pour lutter contre la horde maléfique. Mais avec des zombies bien plus nombreux que vous, toute erreur pourrait entraîner des conséquences graves. Vous devez trouver un moyen de survivre à cette crise.",
      "instructions": "Fais juste courir et tire !",
      "genres": [
        "Accordéon",
        "Tirez"
      ],
      "tags": [
        "arène",
        "armes à feu",
        "amélioration",
        "armes"
      ]
    }
  }
};
